"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _browserStorage = _interopRequireDefault(require("../utils/browserStorage"));
/**
 * Wrapper class to handle access to browser storage.
 */
class WebStorage {
  /**
   * constructs an instance of WebStorage.
   */
  constructor() {
    this.store = null;
    this.prefix = 'icis.';
    this.store = (0, _browserStorage.default)();
  }
  /**
   * Sets an item in browser storage.
   *
   * @param {String} key The key of the item to set.
   * @param {String} value The value of the item to set;
   *
   * @return {Void} Nothing is returned.
   */
  set(key, value) {
    const fullKey = this.prefix + key;
    this.store.setItem(fullKey, value);
  }

  /**
   * Gets an item from browser storage.
   *
   * @param {String} key The key to get from browser storage.
   *
   * @return {String} The value of the requested item.
   */
  get(key) {
    const fullKey = this.prefix + key;
    return this.store.getItem(fullKey);
  }

  /**
   * Removes an item from browser storage.
   *
   * @param {String} key The item to remove from browser storage.
   *
   * @return {Void} nothing is returned.
   */
  remove(key) {
    const fullKey = this.prefix + key;
    this.store.removeItem(fullKey);
  }

  /**
   * Removes all keys with a given prefix
   *
   * @param {String} prefix The prefix of keys to remove from browser storage.
   *
   * @return {Void} nothing is returned.
   */
  removeAllWithPrefix(prefix) {
    const allKeys = this.getAllKeys();
    allKeys.forEach(key => {
      if (key.startsWith(prefix)) {
        this.remove(key);
      }
    });
  }

  /**
   * Gets all of the keys related to our app.
   *
   * @return {Array<String>} All the keys related to this app.
   */
  getAllKeys() {
    const keys = [];
    for (let i = 0; i < this.store.length; i += 1) {
      const key = this.store.key(i);
      if (key.startsWith(this.prefix)) {
        keys.push(key.substr(this.prefix.length));
      }
    }
    return keys;
  }

  /**
   * Removes all of the keys related to our app.
   *
   * @return {Void} Nothing is returned.
   */
  removeAll() {
    const allKeys = this.getAllKeys();
    allKeys.forEach(key => {
      this.remove(key);
    });
  }
}
exports.default = WebStorage;